import { render } from "./TechInstrumentSub.vue?vue&type=template&id=3e3869e6"
import script from "./TechInstrumentSub.vue?vue&type=script&lang=js"
export * from "./TechInstrumentSub.vue?vue&type=script&lang=js"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__